import { MathUtils, Mesh, MeshBasicMaterial, Object3D } from 'three';
import { FontResourcesPackage } from '../../../../../../common/resources/FontResourcesPackage';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { LocalizationModel } from '../../../../../../common/models/LocalizationModel';
import { LocalizationKey } from '../../../../../../localization/Localization';
import { Ticker } from 'pixi.js';

export class PortalText extends Object3D {
    private textGeometry: TextGeometry;
    private textMaterial: MeshBasicMaterial;
    private textMesh: Mesh;

    private animationTime = 0;
    private animationDuration = 1000;

    constructor(fontResources: FontResourcesPackage, localization: LocalizationModel, key: LocalizationKey = LocalizationKey.Click3) {
        super();
        this.textGeometry = new TextGeometry(localization.getText(key), {
            font: fontResources.assets_fonts_DelaGothicOne_Regular_fontjson,
            size: 0.5,
            curveSegments: 12,
            bevelEnabled: false 
        });
        this.textGeometry.computeBoundingBox();
        const bbox = this.textGeometry.boundingBox;
        const centerX = (bbox.max.x + bbox.min.x) / 2;
        const centerY = (bbox.max.y + bbox.min.y) / 2;
        const centerZ = (bbox.max.z + bbox.min.z) / 2;

        this.textGeometry.translate(-centerX, -centerY, -centerZ);
        this.textMaterial = new MeshBasicMaterial({ color: 0xffffff });
        this.textMesh = new Mesh(this.textGeometry, this.textMaterial);
        this.textMesh.rotation.set(MathUtils.degToRad(10), Math.PI + MathUtils.degToRad(10), MathUtils.degToRad(10));
        this.textMesh.scale.set(0, 0, 0);
        this.add(this.textMesh);
        Ticker.shared.add(this.onTick, this);
    }

    private onTick(dt: number): void {
        this.animationTime += dt * 20;
        let t = (this.animationTime % this.animationDuration) / this.animationDuration;

        const scaleValue = t;
        this.textMesh.scale.set(scaleValue, scaleValue, 0);

        this.textMesh.position.y = 0.25 + (1.25 - 0.25) * t;
    }

    public destroy(): void {
        Ticker.shared.remove(this.onTick, this);
        if (this.textMesh) {
            if (this.textMesh.parent) {
                this.textMesh.parent.remove(this.textMesh);
            }

            this.textMesh.geometry.dispose();

            if (Array.isArray(this.textMesh.material)) {
                this.textMesh.material.forEach(m => m.dispose());
            } else {
                this.textMesh.material.dispose();
            }

            this.textMesh = null;
        }
    }
}
